<template>
    <div v-if="hasImages" class="carousel-wrapper" @touchstart="onTouchStart" @touchmove="onTouchMove"
        @touchend="onTouchEnd">
        <transition :name="transitionName" mode="out-in">
            <img class="carousel-image" :class="{ loaded: imageLoaded }" :key="currentImage" :src="currentImage"
                loading="lazy" decoding="async" @load="imageLoaded = true" alt="Carousel Image" />
        </transition>

        <!-- arrows -->
        <span class="carousel-btn prev" @click="prev">‹</span>
        <span class="carousel-btn next" @click="next">›</span>
    </div>
</template>

<script>
export default {
    name: "SimpleCarousel",

    props: {
        images: {
            type: Array,
            default: () => []
        },
        transition: {
            type: String,
            default: "fade" // "fade" or "slide"
        }
    },

    data() {
        return {
            index: 0,
            imageLoaded: false,
            startX: 0,
            deltaX: 0
        };
    },

    watch: {
        currentImage() {
            this.imageLoaded = false;
        }
    },

    computed: {
        hasImages() {
            return Array.isArray(this.images) && this.images.length > 0;
        },
        currentImage() {
            return this.images[this.index];
        },
        transitionName() {
            return this.transition === "slide" ? "slide" : "fade";
        }
    },

    methods: {
        next() {
            this.index = (this.index + 1) % this.images.length;
        },
        prev() {
            this.index = (this.index - 1 + this.images.length) % this.images.length;
        },

        onTouchStart(e) {
            this.startX = e.touches[0].clientX;
        },
        onTouchMove(e) {
            this.deltaX = e.touches[0].clientX - this.startX;
        },
        onTouchEnd() {
            if (this.deltaX > 50) this.prev();
            else if (this.deltaX < -50) this.next();
            this.deltaX = 0;
        }
    }
};
</script>